import { Icon, IconName } from '@usealloy/component-library';
import React from 'react';
import { FOLDER_NODE_ID } from 'flow/service/graph';
import type { FolderNode as IFolderNode, WorkflowNodeProps } from 'flow/service/graph';
import BaseNode from '../BaseNode';
import { useAppSelector } from '~/store/reduxHooks';
import { selectFolderSize, selectHoveredNodeId, selectNodeFolderState } from 'flow/store/redux/selectors';
import { StyledCaretIcon, StyledSizeBadge } from './styles';

function FolderNode(props: WorkflowNodeProps<IFolderNode>) {
  const {
    id,
    type,
  } = props;

  const { isCollapsed } = useAppSelector(selectNodeFolderState);
  const folderSize = useAppSelector(selectFolderSize);
  const hoveredNodeId = useAppSelector(selectHoveredNodeId);

  const iconArrow = isCollapsed ? IconName.CaretDown : IconName.CaretUp;

  return (
    <BaseNode
      icon={
        <Icon icon={IconName.Input} size="large" />
      }
      id={id}
      label="Input"
      stateStyle={{
        baseBackgroundColor: 'var(--cl-juicyBlue-100)',
        hovered: {
          backgroundColor: 'var(--cl-juicyBlue-200)',
        },
      }}
      type={type}
    >
      <>
        <StyledSizeBadge
          isHovered={hoveredNodeId === FOLDER_NODE_ID.inputAttribute}
        >
          {folderSize}
        </StyledSizeBadge>
        <StyledCaretIcon icon={iconArrow} />
      </>
    </BaseNode>
  );
}

export default React.memo(FolderNode);
